import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyC0lyZeAzEJAOrluNSyGXpsvX97UrwR1_Y",
    authDomain: "discord-clone-92610.firebaseapp.com",
    projectId: "discord-clone-92610",
    storageBucket: "discord-clone-92610.appspot.com",
    messagingSenderId: "42970592038",
    appId: "1:42970592038:web:e9daf677709485af5387e7",
    measurementId: "G-X5MZHZ8WJL"
  };

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();

export { auth, provider, db };
export default db;